module.exports = __webpack_public_path__ + "img/drop-invert.73d6d2ec.svg";